import React from 'react'
import PropTypes from 'prop-types'
import Authorization from '../../../security/component/auth/AuthorizationContainer'
import {
    ROLE_PRODUCTION_ADMIN,
    ROLE_EMPLOYEE_CUSTOMER_SERVICE,
    ROLE_CUSTOMER_SERVICE_TEAM_LEAD,
    ROLE_USER_ADMIN, ROLE_2ND_LEVEL_LEGAL, ROLE_ACCOUNTING
} from '../../../security/state/auth/const'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ResponseFeedbackModal from "./ResponseFeedbackModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";

const ACCOUNT_FIX = {
    send_create_account_mail: 'Create account mail sent.',
    password_reset: 'Password reset mail sent.',
}

const BUTTON_STYLE = {
    marginRight: '5px'
}

const CustomerToolbar = (
    {
        startRefinementSetProcess,
        startAlignerReproductionProcess,
        startPartialRefundProcess,
        startEscalationProcess,
        startRefinementShopProcess,
        startRetainerRefinementProcess,
        accountFix,
        fixAccountProblem,
        startDownloadCustomerData,
        closeResponseFeedbackModal,
        responseFeedback,
        openDeleteConfirmationModal,
        closeDeleteConfirmationModal,
        handleDeleteConfirmationModal,
        deleteConfirmationModal,
        deleteCustomer,
        showError
    }
) => {
    return (
        <Row>
            <Column size={12}>

                <Authorization requiredRole={ROLE_EMPLOYEE_CUSTOMER_SERVICE}>
                    <button
                        style={BUTTON_STYLE}
                        className="btn btn-primary btn-sm"
                        onClick={fixAccountProblem}>
                        <i className="fa fa-wrench"/>
                        &#160;fix account problem
                    </button>

                    {ACCOUNT_FIX[accountFix]}


                    {/*<button*/}
                    {/*    style={BUTTON_STYLE}*/}
                    {/*    className="btn btn-warning btn-sm"*/}
                    {/*    onClick={startRefinementSetProcess}>*/}
                    {/*    <i className="fa fa-play"/>*/}
                    {/*    &#160;Start Refinement (Set)*/}
                    {/*</button>*/}

                    <button
                        style={BUTTON_STYLE}
                        className="btn btn-warning btn-sm"
                        onClick={startRefinementShopProcess}>
                        <i className="fa fa-play"/>
                        &#160;Start Refinement (Booking)
                    </button>

                    <button
                        style={BUTTON_STYLE}
                        className="btn btn-warning btn-sm"
                        onClick={startRetainerRefinementProcess}>
                        <i className="fa fa-play"/>
                        &#160;Start Retainer Refinement (Shop)
                    </button>

                    <button
                        style={BUTTON_STYLE}
                        className="btn btn-warning btn-sm"
                        onClick={startEscalationProcess}>
                        <i className="fa fa-play"/>
                        &#160;Start Escalation
                    </button>
                </Authorization>
                <Authorization requiredRole={[ROLE_EMPLOYEE_CUSTOMER_SERVICE, ROLE_PRODUCTION_ADMIN]}>

                    <button
                        style={BUTTON_STYLE}
                        className="btn btn-warning btn-sm"
                        onClick={startAlignerReproductionProcess}>
                        <i className="fa fa-play"/>
                        &#160;Start Aligner Reproduction
                    </button>
                </Authorization>
                <Authorization requiredRole={[ROLE_EMPLOYEE_CUSTOMER_SERVICE, ROLE_CUSTOMER_SERVICE_TEAM_LEAD, ROLE_ACCOUNTING]}>

                    <button
                        style={BUTTON_STYLE}
                        className="btn btn-warning btn-sm"
                        onClick={startPartialRefundProcess}>
                        <i className="fa fa-play"/>
                        &#160;Partial Refund
                    </button>
                </Authorization>
                <Authorization requiredRole={[ ROLE_USER_ADMIN, ROLE_CUSTOMER_SERVICE_TEAM_LEAD, ROLE_2ND_LEVEL_LEGAL ]}>

                    <button
                        style={BUTTON_STYLE}
                        className="btn btn-primary btn-sm"
                        onClick={startDownloadCustomerData}>
                        <i className="fa fa-download"/>
                        &#160;Download Patient Data
                    </button>
                </Authorization>
                <Authorization requiredRole={[ROLE_CUSTOMER_SERVICE_TEAM_LEAD, ROLE_2ND_LEVEL_LEGAL]}>

                    <button
                        style={BUTTON_STYLE}
                        className="btn btn-danger btn-sm"
                        onClick={openDeleteConfirmationModal}>
                        <i className="fa fa-trash-o"/>
                        &#160;Delete Patient
                    </button>
                </Authorization>
            </Column>
            <ResponseFeedbackModal closeResponseFeedbackModal={closeResponseFeedbackModal} responseFeedback={responseFeedback}/>
            <DeleteConfirmationModal closeDeleteConfirmationModal={ closeDeleteConfirmationModal} deleteConfirmationModal={deleteConfirmationModal} handleDeleteConfirmationModal={handleDeleteConfirmationModal} deleteCustomer={deleteCustomer} showError={showError}/>
        </Row>
    )
}

CustomerToolbar.propTypes = {
    startRefinementSetProcess: PropTypes.func,
    startAlignerReproductionProcess: PropTypes.func,
    startPartialRefundProcess: PropTypes.func,
    startEscalationProcess: PropTypes.func,
    startRefinementShopProcess: PropTypes.func,
    startRetainerRefinementProcess: PropTypes.func,
    fixAccountProblem: PropTypes.func,
    accountFix: PropTypes.object,
    startDownloadCustomerData: PropTypes.func,
    closeResponseFeedbackModal: PropTypes.func,
    responseFeedback: PropTypes.object,
    openDeleteConfirmationModal: PropTypes.func,
    closeDeleteConfirmationModal: PropTypes.func,
    deleteConfirmationModal: PropTypes.object,
    handleDeleteConfirmationModal: PropTypes.func,
    deleteCustomer: PropTypes.func,
    showError: PropTypes.func
}

export default CustomerToolbar



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/CustomerToolbar.js